import FormSection from './FormSection'
import { translations } from '../../data/translations'

const ComplianceSection = ({ formData, updateFormData, language }) => {
  const t = translations[language]?.compliance || translations.de.compliance

  const handleCheckboxChange = (field, value) => {
    const currentValues = formData[field] || []
    const newValues = currentValues.includes(value)
      ? currentValues.filter(v => v !== value)
      : [...currentValues, value]
    updateFormData(field, newValues)
  }

  return (
    <FormSection
      title={t.title}
      subtitle={t.subtitle}
    >
      {/* 9.1 Compliance-Anforderungen */}
      <div className="subsection">
        <div className="subsection-title">{t.subtitle1}</div>
        
        <div className="form-group">
          <label>{t.complianceAnforderungen} <span className="required">*</span></label>
          <div className="checkbox-group" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))' }}>
            {t.complianceOptionen.map(option => (
              <div key={option.value} className="checkbox-item">
                <input
                  type="checkbox"
                  id={`comp-${option.value}`}
                  checked={(formData.compliance || []).includes(option.value)}
                  onChange={() => handleCheckboxChange('compliance', option.value)}
                />
                <label htmlFor={`comp-${option.value}`}>{option.label}</label>
              </div>
            ))}
          </div>
          <div className="form-group" style={{ marginTop: '14px' }}>
            <label htmlFor="compliance_weitere">{t.complianceWeitere}</label>
            <input
              type="text"
              id="compliance_weitere"
              name="compliance_weitere"
              value={formData.compliance_weitere || ''}
              onChange={(e) => updateFormData('compliance_weitere', e.target.value)}
              placeholder={t.complianceWeiterePlaceholder}
            />
          </div>
        </div>
      </div>

      {/* 9.2 Sicherheitsanforderungen */}
      <div className="subsection">
        <div className="subsection-title">{t.subtitle2}</div>
        
        <div className="form-group">
          <label>{t.sicherheitsFeatures}</label>
          <div className="checkbox-group" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))' }}>
            {t.sicherheitOptionen.map(option => (
              <div key={option.value} className="checkbox-item">
                <input
                  type="checkbox"
                  id={`sec-${option.value}`}
                  checked={(formData.sicherheit || []).includes(option.value)}
                  onChange={() => handleCheckboxChange('sicherheit', option.value)}
                />
                <label htmlFor={`sec-${option.value}`}>{option.label}</label>
              </div>
            ))}
          </div>
        </div>

        <div className="form-group">
          <label>{t.sensibleDaten} <span className="required">*</span></label>
          <div className="checkbox-group" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))' }}>
            {t.sensibleDatenOptionen.map(option => (
              <div key={option.value} className="checkbox-item">
                <input
                  type="checkbox"
                  id={`data-${option.value}`}
                  checked={(formData.sensible_daten || []).includes(option.value)}
                  onChange={() => handleCheckboxChange('sensible_daten', option.value)}
                />
                <label htmlFor={`data-${option.value}`}>{option.label}</label>
              </div>
            ))}
          </div>
        </div>

        <div className="form-group">
          <label htmlFor="datenschutz_anmerkungen">{t.datenschutzAnmerkungen}</label>
          <textarea
            id="datenschutz_anmerkungen"
            name="datenschutz_anmerkungen"
            value={formData.datenschutz_anmerkungen || ''}
            onChange={(e) => updateFormData('datenschutz_anmerkungen', e.target.value)}
            placeholder={t.datenschutzAnmerkungenPlaceholder}
            style={{ minHeight: '80px' }}
          />
        </div>
      </div>
    </FormSection>
  )
}

export default ComplianceSection
